var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { useCanAccess, useCreatePath, useGetResourceLabel, useResourceDefinitions, } from 'react-admin';
import { HorizontalMenuItem, } from './HorizontalMenuItem';
export var HorizontalMenuResourceItem = React.forwardRef(function HorizontalMenuResourceItem(_a, ref) {
    var resource = _a.resource, value = _a.value, rest = __rest(_a, ["resource", "value"]);
    var resources = useResourceDefinitions();
    var getResourceLabel = useGetResourceLabel();
    var createPath = useCreatePath();
    var _b = useCanAccess({
        action: 'list',
        resource: resource,
    }), canAccess = _b.canAccess, error = _b.error, isPending = _b.isPending;
    if (Object.keys(resources).length === 0)
        return null;
    if (!resources[resource]) {
        throw new Error("The ".concat(resource, " resource is unknown. Please provide a name that matches a resource declared in one of your <Resource> components."));
    }
    if (isPending || canAccess === false || error != null)
        return null;
    return (_jsx(HorizontalMenuItem, __assign({ value: resource, label: getResourceLabel(resource, 2), to: createPath({ resource: resource, type: 'list' }), state: { _scrollToTop: true }, ref: ref }, rest)));
});
// @ts-expect-error The valueProp is used by HorizontalMenu to set the value to the resource
HorizontalMenuResourceItem.valueProp = 'resource';
